import * as RadixSwitch from "@radix-ui/react-switch";
import styles from "./Switch.module.scss";
import classNames from "classnames";

type SwitchProps = {
  checked?: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  className?: string;
  isButton?: boolean;
  id?: string;
};

export default function Switch({
  checked,
  defaultChecked,
  disabled,
  onCheckedChange,
  className,
  isButton = true,
  id,
}: SwitchProps) {
  return (
    <RadixSwitch.Root
      id={id}
      className={classNames(styles.root, className)}
      checked={checked}
      disabled={disabled}
      defaultChecked={defaultChecked}
      onCheckedChange={onCheckedChange}
      asChild={!isButton}
    >
      {isButton ? (
        <RadixSwitch.Thumb className={styles.thumb} />
      ) : (
        <span>
          <RadixSwitch.Thumb className={styles.thumb} />
        </span>
      )}
    </RadixSwitch.Root>
  );
}
